import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const SearchIcon: React.FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="search icon">
      {/* <title>search icon</title> */}
      <path
        d="M17.7531 16.7188L13.5656 12.5312C14.4719 11.4219 14.9719 10.025 14.9719 8.5C14.9719 4.90937 12.0616 2 8.47188 2C4.88219 2 2 4.91031 2 8.5C2 12.0897 4.91001 15 8.47188 15C9.99657 15 11.3953 14.4716 12.5031 13.5925L16.6906 17.78C16.8656 17.9281 17.0594 18 17.25 18C17.4406 18 17.6338 17.9268 17.7803 17.7803C18.0719 17.4875 18.0719 17.0125 17.7531 16.7188ZM3.50001 8.5C3.50001 5.74312 5.74313 3.5 8.50001 3.5C11.2569 3.5 13.5 5.74312 13.5 8.5C13.5 11.2569 11.2569 13.5 8.50001 13.5C5.74313 13.5 3.50001 11.2563 3.50001 8.5Z"
        fill={props.fill || "currentColor" || "#52525B"}
      />
    </svg>
  );
};

export default SearchIcon;
